import firebase from 'firebase'

var config = {
  apiKey: "AIzaSyAi9YffE9wl7MS-Yzg3OX6AlsNHnMFw2NY",
  authDomain: "url-muse.firebaseapp.com",
  databaseURL: "https://url-muse.firebaseio.com",
  projectId: "url-muse",
  storageBucket: "",
  messagingSenderId: "925313415576"
}

const fire = firebase.initializeApp(config)

export const auth = firebase.auth()

export default fire



// WEBPACK FOOTER //
// ./src/fire.js